import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { trocarCodePorSessao } from '../services/auth.js';
import { useAuth } from '../hooks/useAuth.jsx';

export default function AuthCallback() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { recarregar } = useAuth();
  const [erro, setErro] = useState(null);

  useEffect(() => {
    const code = params.get('code');
    const state = params.get('state');
    const erroQs = params.get('error');

    if (erroQs) {
      setErro(`Falha no login: ${erroQs}`);
      return;
    }
    if (!code) {
      setErro('Código de autorização ausente.');
      return;
    }

    (async () => {
      try {
        await trocarCodePorSessao(code, state);
        await recarregar();
        navigate('/', { replace: true });
      } catch (e) {
        setErro(e.message || 'Falha ao concluir login.');
      }
    })();
  }, [params, navigate, recarregar]);

  return (
    <div role="status" aria-live="polite">
      {erro ? <div className="alert alert-danger">{erro}</div> : <p>Concluindo seu login…</p>}
    </div>
  );
}
